module.exports = __webpack_public_path__ + "img/FPT23.d4505954.svg";